import { useState } from 'react';

interface Service {
  id: number;
  icon: string;
  title: string;
  description: string;
  items: string[];
  gradient: string;
}

const services: Service[] = [
  {
    id: 1,
    icon: 'ri-phone-line',
    title: 'Lead Generation & Sales Support',
    description: 'We help you find qualified leads, book meetings, and close more deals consistently.',
    items: ['Cold Calling', 'Appointment Setting', 'Skip Tracing', 'CRM Management & Follow-Ups'],
    gradient: 'from-[#004aad] to-[#0066dd]'
  },
  {
    id: 2,
    icon: 'ri-user-settings-line',
    title: 'Administrative & Executive Support',
    description: 'Stay organized and productive while we manage your day-to-day tasks.',
    items: ['Virtual / Executive Assistant', 'Administrative Support', 'Data Entry & Spreadsheet Management', 'Document Handling & Reporting'],
    gradient: 'from-[#ffbd59] to-[#ffa726]'
  },
  {
    id: 3,
    icon: 'ri-calculator-line',
    title: 'Accounting & Payroll Support',
    description: 'Accurate, confidential, and well-managed financial support for your business.',
    items: ['Bookkeeping Assistance', 'Payroll Processing Support', 'Invoicing & Expense Tracking'],
    gradient: 'from-[#004aad] to-[#0066dd]'
  },
  {
    id: 4,
    icon: 'ri-palette-line',
    title: 'Design & Branding',
    description: 'Professional designs that strengthen your brand and attract customers.',
    items: ['Graphic Design', 'Social Media Design', 'Marketing Creatives'],
    gradient: 'from-[#ffbd59] to-[#ffa726]'
  },
  {
    id: 5,
    icon: 'ri-megaphone-line',
    title: 'Marketing & Outreach',
    description: 'Reach the right audience with the right message at the right time.',
    items: ['Social Media Marketing', 'Text Blasting (SMS Campaigns)', 'Email Outreach', 'Campaign Setup & Monitoring'],
    gradient: 'from-[#004aad] to-[#0066dd]'
  }
];

export default function Services() {
  const [expandedCard, setExpandedCard] = useState<number>(1);

  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">
            Our Services <span className="text-4xl">🚀</span>
          </h2>
          <p className="text-xl text-gray-600">
            Comprehensive solutions for every business need
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => (
            <div
              key={service.id}
              onMouseEnter={() => setExpandedCard(service.id)}
              className={`bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer ${
                expandedCard === service.id ? 'ring-4 ring-[#ffbd59] transform scale-105' : ''
              }`}
            >
              <div className={`w-16 h-16 rounded-full bg-gradient-to-br ${service.gradient} flex items-center justify-center mb-6`}>
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-gray-600 mb-6">{service.description}</p>
              
              <div className={`space-y-3 transition-all duration-300 ${
                expandedCard === service.id ? 'opacity-100 max-h-96' : 'opacity-0 max-h-0 overflow-hidden'
              }`}>
                {service.items.map((item, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-[#004aad] text-xl mt-0.5"></i>
                    <span className="text-gray-700">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}